/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import { Button, Grid } from '@material-ui/core'
import { JsonObject } from '@ts/json'
import { Rename } from '@ts/utils'
import React, { ReactElement } from 'react'
import { FormProps } from 'react-jsonschema-form'

import Form from './shared/Form'

export type DynamicFormLayoutProps = Rename<FormProps<JsonObject>, 'formData', 'data'> & {
  children?: ReactElement
}

const defaultSubmit = (
  <Grid container justify="flex-end">
    <Button color="secondary" size="large" type="submit" variant="contained">
      Save
    </Button>
  </Grid>
)

const DynamicFormLayout = (props: DynamicFormLayoutProps) => {
  const { children = defaultSubmit, data, schema, uiSchema, formContext, ...formProps } = props

  return (
    <Form
      formContext={formContext}
      formData={data}
      schema={schema}
      uiSchema={uiSchema}
      {...formProps}
    >
      {children}
    </Form>
  )
}
export default DynamicFormLayout
